const utcToDate = (value, arg) => {
  let utc = localStorage.getItem('utc')
  if (utc === null) {
    utc = new Date().getTimezoneOffset()
  }
  value = value - (utc * 60000)
  return value
}

export default utcToDate



// WEBPACK FOOTER //
// app/javascript/src/vue/filters.js